module.exports = __webpack_public_path__ + "assets/img/fanganLogo.9a72abf5.png";